export const toDecimal = (value: string) => {

    let predecimal = value.replace(/[^0-9\.]/g, "");
    let hasPeriod = false;
    let decimal = [...predecimal].filter(letter => {
        if (letter == "." && hasPeriod) return false;
        if (letter == "." && !hasPeriod) {
            hasPeriod = true;
        }
        return true;
    }).join('');

    return decimal;
}
export const toInteger = (value: string) => {

    return value.replace(/[^0-9]/g, "");
}

export const toFixed = (value: string) => String(Number(value).toFixed(2));

export const toMoney = (value: string) => (Number(value)).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
})